import { FC, MouseEventHandler } from 'react';

import { IconButton } from '@mui/material';
import { clsx } from 'clsx';

import { ReactComponent as CrossIcon } from 'assets/icons/CrossIcon.svg';
import { ReactComponent as MenuIcon } from 'assets/icons/MenuIcon.svg';

import styles from './MenuButtonTemplate.module.scss';

interface IMenuButtonTemplateProps {
  className?: string;
  variant?: 'hamburger' | 'cross';
  onClick?: MouseEventHandler;
}

export const MenuButtonTemplate: FC<IMenuButtonTemplateProps> = ({ className, variant = 'hamburger', onClick }) => {
  return (
    <IconButton className={clsx(styles.iconButton, className)} onClick={onClick}>
      {variant === 'cross' ? <CrossIcon /> : <MenuIcon />}
    </IconButton>
  );
};
